import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import OurMissionContent from '../../components/Pages/OurMission';

const { displayName } = config;

export default function OurMission(): React.ReactElement {
  document.title = `${displayName}: Our Mission`;

  return (
    <Layout>
      <OurMissionContent />
    </Layout>
  );
}
